// removed by extract-text-webpack-plugin
module.exports = {"CategoryItem":"CategoryItem__CategoryItem__2t7yK","CategoryLogo":"CategoryItem__CategoryLogo__15nrI","CategoryImage":"CategoryItem__CategoryImage__3MOJR","CategoryName":"CategoryItem__CategoryName__21TLr","Gold":"CategoryItem__Gold__2H8rQ","CategoryItemLink":"CategoryItem__CategoryItemLink__1L0V7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CategoryItem/CategoryItem.css
// module id = 223
// module chunks = 0